<template>
    <div class="assemble-my-order">
        <!-- 选项卡 -->
        <div class="flex__around__center nav">
            <div class="flex align-center nav__item" :class="loads.index==index?'active':''" v-for="(item,index) in nav_list" :key="index" @click="link('/Assemble/MyOrder?index='+index,index)">
                <span class="fs_30" :class="loads.index==index?'c_1a fw_500':'c_66'">{{item.text}}</span>
            </div>
        </div>
        <div class="list">
            <div class="list__item" v-for="(item,index) in list" :key="item.id">
                <div class="flex__between__center list__item__header"> 
                    <span class="fs_26 c_66">{{item.order_number}}</span>
                    <span class="fs_28" :class="item.status==1||item.status==2||item.status==3||item.status==4||item.status==6?'c_main':'c_b3'" v-if="item.status!=2">{{item.status_name}}</span>
                    <div v-if="item.status==2" class="flex__column flex__between__end">
                        <div>
                            <span class="fs_28 c_1a">拼团中,还差</span>
                            <span class="fs_28 c_main">{{item.rest_number}}人</span>
                            <span class="fs_28 c_1a">成团</span>
                        </div>
                        <span class="fs_22 c_98 mt_10">剩{{item.hour}}:{{item.minute}}:{{item.second}}</span>
                    </div>
                </div>
                <div class="item-box" v-link="'/Assemble/OrderDetail/'+item.id">
                    <div class="flex item" v-for="(item1,index1) in item.order_product" :key="index1">
                        <img :src="item1.product_cover_img" alt="">
                        <div class="flex__null__around item__right">
                            <span class="fs_26 c_1a lh_36 ellipsis_two">{{item1.product_name}}</span>
                            <span class="fs_22 c_98" v-if="item1.product_sku_name">规格: {{item1.product_sku_name}}</span>
                            <div class="flex__between">
                                <span class="fs_30 c_main"><span class="fs_22">¥</span>{{item1.product_price}}</span>
                                <span class="fs_26 c_80">x{{item1.number}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="list__item__footer">
                    <div class="flex__end__center list__item__footer__top">
                        <span class="fs_24 c_4d">合计：</span>
                        <span class="fs_30 c_main"><span class="fs_22">¥</span>{{item.pay_money}}</span>
                    </div>
                    <div class="flex__end__center list__item__footer__bottom" v-if="item.status!=6">
                        <button class="hollow-btn" v-if="item.status==1" @click="cancel(item.id)">取消订单</button>
                        <button class="hollow-btn" v-if="item.status==2" v-link="'/Assemble/RegimentDetail/'+item.group_id ">拼团详情</button>
                        <!-- <button class="solid-btn" v-if="item.status==2" @click="share(item.group_id)">邀请参团</button> -->
                        <button class="hollow-btn" v-if="item.status==8||item.status==5||item.status==6||item.status==9" @click="del(item.id)">删除订单</button>
                        <button class="hollow-btn" v-if="item.status==4||item.status==5||item.status==6" @click="setLogistics(item.id)">查看物流</button>
                        <button class="hollow-btn" v-if="item.status==3" @click="refund(item.id,)">申请退款</button>
                        <button class="solid-btn" v-if="item.status==5" v-link="'/Assemble/Evaluate/'+item.id">评价</button>
                        <button class="solid-btn" v-if="item.status==4" @click="harvest(item.id)">确认收货</button>
                        <button class="solid-btn" v-if="item.status==1" @click="pay(item.id)">支付</button>
                        <button class="solid-btn" v-if="item.status==3" @click="remind(item.id)">提醒发货</button>
                    </div>
                </div>
            </div>
        </div>
        <jc-list v-if="refresh" :url="'/Collage/getMyOrderList'" :loads="loads" @load='getList'></jc-list>
        <!-- 分享浮层 -->
        <share-layer :show_share="share_show" @isShow="isShow"></share-layer>
    </div>
</template>
<script>
export default {
    name:"AssembleMyOrder",
    data(){
        return{
            share_show: false,//分享图层
            refresh: true, //刷新组件用
            list: [],
            loads:{
                user_id: localStorage.user_id,
                index: 0
            },
            nav_list:[
                {text:'全部',status: 0},
                {text:'待支付',status: 1},
                {text:'拼团中',status: 2},
                {text:'待发货',status: 3},
                {text:'待收货',status: 4},
                {text:'待评价',status: 5}
            ] 
        }
    },
    methods:{
        link(url,index){
            this.$router.push(url);
            this.loads.index=index;
        },
        // 分享图层
        isShow(data){
            this.share_show=data;
        },
        getList (data) { 
            for(let i=0;i<data.length;i++){
                if(data[i].status==2){
                    this.countTime(data[i].end_time,data[i].interval,time_res=>{
                        this.$set(data[i],'hour',time_res.hrStr);
                        this.$set(data[i],'minute',time_res.minStr);
                        this.$set(data[i],'second',time_res.secStr);
                    });
                }
            }
            this.list=data;
        },
        // 分享
        // shareGroup(id,img){
        //     // 分享预配置
        //     this.$wx.setConfig();
        //     this.$wx.share({
        //         title: this.group.product_name, 
        //         link:"https://ym.jucheng01.net/vue/#/Assemble/RegimentDetail/" + this.$route.params.id,
        //         imgUrl: this.group.product_cover_img 
        //     })
        // },
        // 提醒发货
        remind(id){
            this.axios.post('/wechat.php/Collage/submitOrderRemind',{
                user_id: localStorage.user_id,
                order_id: id
            }).then(
                res=>{
                    this.$dialog.alert({
                        message: res.data.message
                    })
                }
            )
        },
        // 取消订单
        cancel(id){
            this.refresh=false;
            this.$dialog.confirm({
                message: '确认取消该订单？'
            }).then(() => {
                this.axios.post('/wechat.php/Collage/submitOrderCancel',{
                    user_id: localStorage.user_id,
                    order_id: id
                }).then(
                    res=>{
                        this.refresh=true;
                        this.$dialog.alert({
                            message: res.data.message
                        })
                    }
                )
            }).catch(()=>{})
        },
        // 申请退款
        refund(id){
            this.refresh=false;
            this.$dialog.confirm({
                message: '确认申请退款该订单？'
            }).then(() => {
                this.axios.post('/wechat.php/Collage/submitOrderRefund',{
                    user_id: localStorage.user_id,
                    order_id: id
                }).then(
                    res=>{
                        this.refresh=true;
                        this.$dialog.alert({
                            message: res.data.message
                        })
                    }
                )
            }).catch(()=>{})
        },
        // 删除订单
        del(id){
            this.refresh=false;
            this.$dialog.confirm({
                message: '确认删除该订单？'
            }).then(() => {
                this.axios.post('/wechat.php/Collage/submitOrderDelete',{
                    user_id: localStorage.user_id,
                    order_id: id
                }).then(
                    res=>{
                        this.refresh=true;
                        this.$dialog.alert({
                            message: res.data.message
                        })
                    }
                ) 
            }).catch(()=>{})
        },
        // 查看物流
        setLogistics(id){
            this.$store.commit('setLogistics','/wechat.php/Collage/getExpressData');
            this.$router.push('/Mall/Logistics/'+id);
        },
        // 确认收货
        harvest(id){
            this.refresh=false;
            this.$dialog.confirm({
                message: '确认收货？'
            }).then(() => {
                this.axios.post('/wechat.php/Collage/submitOrderConfirm',{
                    user_id: localStorage.user_id,
                    order_id: id
                }).then(
                    res=>{
                        this.refresh=true;
                        this.$dialog.alert({
                            message: res.data.message
                        })
                    }
                )
            }).catch(()=>{})
        },
        // 支付
        pay(id){
            this.axios.post('/wechat.php/Collage/submitOrderPay',{
                user_id:localStorage.user_id,
                order_id:id,
            }).then(
                res=>{
                    if(res.data.code==1){
                        let pay={};
                        pay.pay_parameters=res.data.data.pay_parameters;
                        pay.back_link='/Assemble/RegimentDetail/'+res.data.data.group_id;
                        this.$store.commit('setPay',pay);
                        this.$router.push('/Pay');
                    }else{
                        this.$dialog.alert({
                            message: res.data.message
                        })
                    }
                }
            )
        },
        // 计算到计时
        countTime(time,interval_obj,callback){
            let current_time = Date.parse(new Date()) / 1000;
            var totalSecond = time - current_time;
            interval_obj = setInterval(function () {
                // 秒数
                var second = totalSecond;
                // 小时位
                var hr = Math.floor((second) / 3600);
                var hrStr = hr.toString();
                if (hrStr.length == 1) hrStr = '0' + hrStr;

                // 分钟位
                var min = Math.floor((second - hr * 3600) / 60);
                var minStr = min.toString();
                if (minStr.length == 1) minStr = '0' + minStr;

                // 秒位
                var sec = second - hr * 3600 - min * 60;
                var secStr = sec.toString();
                if (secStr.length == 1) secStr = '0' + secStr;
                    callback({
                        hrStr,
                        minStr,
                        secStr})
                    totalSecond--;
                if (totalSecond < 0) {
                    clearInterval(interval_obj);
                    this.$toast('活动已结束');
                    return{
                        hrStr:'00',
                        minStr:'00',
                        minStr:'00'
                    }
                }
            }, 1000);
        }
    },
    mounted(){
        this.loads.index=this.$route.query.index;
    },
    beforeDestroy(){
        for(let i=0;i<this.list.length;i++){
            if(this.list[i].status==2){
                clearInterval(this.list[i].interval);
            }
        }
    }
}
</script>
<style scoped>
.nav{
    position: fixed;
    top: 0;
    width: 100%;
    height: 90px;
    z-index: 1;
    background: #fff;
}
.nav__item.active{
    height: 90px;
    border-bottom: 4px solid #F93A42;
}
.list{
    padding: 90px 20px 0;
}
.list__item{
    margin-top: 15px;
    padding: 0 20px;
    background: #fff;
    border-radius:10px;
}
.list__item__header{
    height: 100px;
}
.item-box{
    padding: 0 0 30px; 
    border-bottom: 2px solid #e6e6e6;
    border-top: 2px solid #e6e6e6;
}
.item{
    margin-top: 30px;
}
.item:last-child{
    border: 0;
}
.item img{
    width: 180px;
    height: 180px;
    border-radius: 10px;
}
.item__right{
    width: 460px;
    margin-left: 30px;
}
.list__item__footer__top{
    height: 90px;
}
.list__item__footer__bottom{
    padding-bottom: 30px;
}
.list__item button{
    width: 160px;
    height: 55px;
    line-height: 55px;
    border-radius:30px;
    margin-left: 10px;
}
.list__item .hollow-btn{
    background: none;
    border: 2px solid #e6e6e6;
    font-size: 26px;
    color: #808080;
}
.list__item .solid-btn{
    background: #F93A42;
    font-size: 26px;
    color: #fff;
}
</style>





// WEBPACK FOOTER //
// src/pages/assemble/MyOrder.vue